const asia = {
  urls: {
    labelsUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=88520980",
    casesUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv",
    incidentsUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=367168864",
    annotUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1785954720",
    stringencyUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=866677213",
  },
};

const africa = {
  urls: {
    labelsUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1192184276",
    casesUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1678654508",
    incidentsUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=2078742025",
    annotUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=328439298",
    stringencyUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1919810629",
  },
};

const eastAfrica = {
  urls: {
    labelsUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=976181745",
    casesUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1469037234",
    incidentsUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=763046317",
    annotUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=2050560408",
    stringencyUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1242351592",
  },
};

const regions = {
  urls: {
    labelsUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1856485037",
    casesUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=638700219",
    incidentsUrl: null,
    // annotUrl:
    //   "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1219296815",
    // annotUrl:
    //   "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1000467645",
    annotUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=528157714",
  },
};

const balkans = {
  urls: {
    labelsUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=959289592",
    casesUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1340718086",
    incidentsUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1441579818",
    annotUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=996190595",
    stringencyUrl:
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vTnzPYtf3GW1zmgZNDw3qAI42XjYzPydcTLffRs35eULkSbCdg217nH-qQ86JUIodGhYtRNgv7B3HqF/pub?output=csv&gid=1680912372",
  },
};

const env = process.env.REACT_APP_STAGE;

console.log("running with env: ", env);

var config;

if (env === "africa") config = africa;
else if (env === "asia") config = asia;
else if (env === "eastafrica") config = eastAfrica;
else if (env === "balkans") config = balkans;
else config = regions;

// const config = process.env.REACT_APP_STAGE === "africa" ? africa : process.env.REACT_APP_STAGE === "asia" ? asia : regions;

const retval = {
  dimensions: {
    height: 600,
    margin: { left: 30, right: 60, bottom: 20, top: 60 },
  },
  ...config,
};
export default retval;
